import { render, staticRenderFns } from "./notAssigned_mr.vue?vue&type=template&id=765ed132"
import script from "./notAssigned_mr.vue?vue&type=script&lang=js"
export * from "./notAssigned_mr.vue?vue&type=script&lang=js"
import style0 from "./notAssigned_mr.vue?vue&type=style&index=0&id=765ed132&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports